import { http } from 'utils'

// Location mutation imports.
import { SET_CONTRACTS } from 'vx/mutations'

// Location state.
const state = {
  contracts: []
}

// Location state getters.
const getters = {}

// Location actions.
const actions = {
  /**
   * Get all locations.
   *
   * @return Promise
   */
  getContracts ({ commit }, params = {}) {
    return http.get('contracts', { params })
      .then((response) => {
        commit(SET_CONTRACTS, response)

        return response
      })
  }
}

// Contracts state mutations.
const mutations = {
  [SET_CONTRACTS] (state, contracts) {
    state.contracts = contracts
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}
